import React, { useEffect } from "react";
import "./ContractModal.css";

const ContractModal = ({ isOpen, onClose }) => {
  // Modal açıkken arka plan scroll'unu engelle ve ESC tuşu ile kapatma
  useEffect(() => {
    if (isOpen) {
      // Modal açıldığında body overflow'unu gizle
      document.body.style.overflow = 'hidden';
      
      // ESC tuşu ile modal kapatma
      const handleEscapeKey = (event) => {
        if (event.key === 'Escape') {
          onClose();
        }
      };
      
      document.addEventListener('keydown', handleEscapeKey);
      
      // Cleanup function - modal kapandığında overflow'u geri yükle ve event listener'ı kaldır
      return () => {
        document.body.style.overflow = 'unset';
        document.removeEventListener('keydown', handleEscapeKey);
      };
    }
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>GENEL SATIŞ ve HİZMET SÖZLEŞMESİ</h2>
          <p className="close-button" onClick={onClose}>
            &times;
          </p>
        </div>
        <div className="modal-body">
          <div className="contract-section">
            <h3>1. SÖZLEŞMENİN KONUSU</h3>
            <p>
              Bu sözleşmenin konusu, Misafir'in Otel tarafından sunulan konaklama ve ilgili diğer hizmetleri
              elektronik ortamda satın almasına ilişkin tarafların hak ve yükümlülüklerinin belirlenmesidir.
            </p>
          </div>

          <div className="contract-section">
            <h3>2. HİZMETLERE İLİŞKİN BİLGİLER</h3>
            <p>
              Misafir, rezervasyon işlemi sırasında seçtiği oda tipi, tarih, kişi sayısı, fiyat ve ödeme bilgilerini
              içeren detayları elektronik ortamda onaylar.
            </p>
            <p>
              Web sitesinde sunulan tüm hizmetlerin fiyatları ve özellikleri güncel olup değişiklik hakkı Otel'e
              aittir.
            </p>
          </div>

          <div className="contract-section">
            <h3>3. ÖDEME KOŞULLARI</h3>
            <p>
              - Misafir, rezervasyon sırasında belirtilen bedeli kredi kartı, havale/EFT veya diğer online ödeme
              yöntemleriyle ödeyebilir.
            </p>
            <p>
              - Otel, gerekli gördüğü hallerde ön provizyon alma veya güvenlik teyidi isteme hakkına sahiptir.
            </p>
          </div>

          <div className="contract-section">
            <h3>4. REZERVASYON, İPTAL ve DEĞİŞİKLİK KOŞULLARI</h3>
            <p>
              - Misafir, iptal ve değişiklik şartlarını rezervasyon esnasında görüp onaylamıştır.
            </p>
            <p>
              - Erken rezervasyon veya promosyonlu satışlarda iade yapılmayabilir.
            </p>
            <p>
              - İptal şartları hizmet türüne göre değişiklik gösterebilir ve rezervasyon esnasında ayrıca
              belirtilir.
            </p>
            <p>
              - Otel, hizmetin verilemeyeceği mücbir sebepler (doğal afet, salgın hastalık, kamu düzenine
              ilişkin kararlar vs.) oluştuğunda, hizmeti iptal etme veya erteleme hakkını saklı tutar.
            </p>
          </div>

          <div className="contract-section">
            <h3>5. MÜCBİR SEBEPLER</h3>
            <p>
              Tarafların kontrolü dışında gelişen ve sözleşmenin ifasını engelleyen durumlarda (savaş, yangın,
              grev, deprem, salgın hastalık vs.) taraflar mücbir sebeplerden sorumlu tutulamaz.
            </p>
          </div>

          <div className="contract-section">
            <h3>6. KİŞİSEL VERİLERİN KORUNMASI</h3>
            <p>
              Misafir'in kişisel verileri, yalnızca hizmetin ifası ve yasal yükümlülüklerin yerine getirilmesi
              amacıyla işlenir. Detaylı bilgi için "Gizlilik Politikası" sayfası incelenmelidir.
            </p>
            <p>
              Otel, KVKK kapsamında gerekli teknik ve idari tedbirleri almakla yükümlüdür.
            </p>
          </div>

          <div className="contract-section">
            <h3>7. FİKRİ ve SINAİ HAKLAR</h3>
            <p>
              Web sitesindeki tüm içerik, görseller, logo ve bilgiler Otel'e aittir. İzinsiz kopyalanamaz,
              çoğaltılamaz, ticari amaçla kullanılamaz.
            </p>
          </div>

          <div className="contract-section">
            <h3>8. YETKİLİ MAHKEME</h3>
            <p>
              İşbu sözleşmeden doğabilecek ihtilaflarda, T.C. Ticaret Bakanlığı tarafından belirlenen parasal
              sınırlara göre Tüketici Hakem Heyetleri ve Tüketici Mahkemeleri yetkilidir.
            </p>
          </div>

          <div className="contract-section">
            <h3>9. YÜRÜRLÜK</h3>
            <p>
              Misafir, web sitesinde rezervasyon işlemini tamamladığında işbu sözleşmenin tüm koşullarını
              okuduğunu, anladığını ve kabul ettiğini beyan eder.
            </p>
            <p>
              İşbu sözleşme elektronik ortamda onaylandığı anda yürürlüğe girer.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContractModal;
